<template>
  <div class="container_szklo">
    <navigation/>
    <div class="wrapper">
      <h2>Szkło grafika</h2>
      <p>Wybierz kategorie</p>
      <div class="grid">
        <router-link tag="div" v-for="cat in categories" :key="cat.id" :to="`category/${cat.to}`" class="single-item">
          <div class="icon" :style="`background-image: url(${cat.url}); background-repeat: no-repeat; background-size: cover; background-position: center;`"></div>
          <p>{{cat.name}}</p>
        </router-link>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import navigation from '@/components/navigation.vue';
import Footer from '@/components/Footer.vue';
export default {
  components:{
    navigation, Footer
  },
  computed:{
    ...mapState({
      categories: state=>state.szkloCategories.categories
    })
  },
  methods:{
      ...mapMutations(['bindCategories'])
  },
  mounted(){
    if(this.categories.length === 0){
      this.bindCategories();
    }
  }
}
</script>

<style scoped lang="scss">
.wrapper{
  margin-top: 120px;
  padding: 0 34px;
}
.footer_container{
  width: 100%;
}
.icon{
  width: 100px;
  height: 100px;
}
.grid{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
.single-item{
  width: 100px;
  height: 140px;
  margin: 0 2px;
}
@media (min-width: 1440px){
    .icon{
      cursor: pointer;
    }
    .wrapper{
      padding: 0 100px;
    }
    .single-item{
      width: 200px;
      height: 240px;
    }
    .icon{
      width: 200px;
      height: 200px;
    }
    .grid{
      margin: 12px 0;
    }

}
</style>